import { callApi } from "../../api";
import { schema } from "normalizr";

const serviceschema = new schema.Entity("services", {
}, {
  idAttribute: service => service.id,
});

export const Schemas = {
  SERVICE: serviceschema,
  SERVICE_ARRAY: [serviceschema],
};

export const loadServices = (useSchema = true) => callApi("services/", { method: "GET", params: {} }, useSchema ? Schemas.SERVICE_ARRAY : null);
